// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__1-Sol","title":"card_title__3Jd7h","inActive":"card_inActive__1LOC1"};